"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface LocalCard {
  id: string;
  title: string;
  body: string;
  linkText: string;
  linkTarget: string;
}
const localCards: LocalCard[] = [{
  id: "karlstad",
  title: "Badrumsrenovering i Karlstad",
  body: "Vi hjälper villa- och lägenhetsägare i Karlstad med omnejd att planera och genomföra badrumsrenoveringar. Med samordnad totalentreprenad, auktoriserade VVS-installationer och behöriga samarbetspartners får du en tydlig process från första planering till färdigt badrum.",
  linkText: "Läs mer om badrumsrenovering i Karlstad →",
  linkTarget: "/BathroomRenovationKarlstadPage"
}, {
  id: "arvika",
  title: "Badrumsrenovering i Arvika",
  body: "Planerar du en renovering i Arvika eller västra Värmland? Vi hjälper dig genom hela processen, från planering och rivning till tätskikt, plattsättning och montering. Arbetet samordnas med behöriga yrkespersoner för ett tryggt och fackmässigt resultat.",
  linkText: "Läs mer om badrumsrenovering i Arvika →",
  linkTarget: "/BathroomRenovationArvikaPage"
}];
export default function VarmlandLokalt() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="varmland-lokalt" aria-labelledby="varmland-lokalt-heading" className="bg-background text-foreground py-16 sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {/* Centered header matching section styling */}
          <div className="text-center mb-16">
            <h2 id="varmland-lokalt-heading" className="font-default text-3xl md:text-5xl font-semibold text-foreground tracking-tight">
              Från idé till färdigt badrum i Värmland
            </h2>
            <div className="mt-4 h-1 w-20 bg-primary mx-auto rounded-full" />
            <p className="mt-6 max-w-3xl mx-auto text-muted-foreground text-base md:text-lg leading-relaxed">
              Har du hittat en stil, planlösning eller materialkombination du gillar? Proffsbadrum hjälper dig att förverkliga idéerna med samordnad totalentreprenad och behöriga yrkespersoner i våra lokala verksamhetsområden.
            </p>
          </div>

          {/* 2-column calm cards grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 items-stretch">
            {localCards.map(card => <article key={card.id} className="bg-card text-card-foreground border border-border rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-10 shadow-xs flex flex-col justify-between transition-shadow duration-300 hover:shadow-sm">
                <div>
                  <div className="flex items-center gap-3.5 mb-5">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0" aria-hidden="true">
                      <MapPin className="w-5 h-5" />
                    </div>
                    <h3 className="font-default text-xl sm:text-2xl font-semibold text-foreground tracking-tight">
                      {card.title}
                    </h3>
                  </div>
                  <p className="text-muted-foreground text-base sm:text-lg leading-relaxed mb-8">
                    {card.body}
                  </p>
                </div>
                <div className="mt-auto pt-2">
                  <Link to={card.linkTarget} className="inline-flex items-center text-primary font-medium underline underline-offset-4 hover:text-primary/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm text-base">
                    {card.linkText}
                  </Link>
                </div>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}